import { render, staticRenderFns } from "./BidActivityChart.vue?vue&type=template&id=b81dcf66&"
import script from "./BidActivityChart.vue?vue&type=script&lang=js&"
export * from "./BidActivityChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports